import { animate, style, transition, trigger } from "@angular/animations";
import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import {
    FormBuilder,
    FormControl,
    FormGroup,
    Validators,
} from "@angular/forms";
import { AccountPlanListProvider, AttendanceListProvider, GroupListProvider, SendingToFinanceListProvider } from "cw-backend";
import moment from "moment";
import { debounceTime, distinctUntilChanged, Subject, takeUntil } from "rxjs";
import {
    BatchEntry,
    CompanyAccountPlan,
    ExameType,
    Group,
    Insurance,
    Patient,
    PayType,
    Professional,
    TypeGuide
} from "../../../../../../../../shared/cw-backend/models/backend-definitions.module";
import { Filter } from "../../../../../../../../shared/cw-backend/models/operational/filter/filter";
import { UserSimple } from "../../../../../../../../shared/cw-backend/models/security/user/user-simple";
import { InsuranceListProvider } from "../../../../../../../../shared/cw-backend/providers/accreditation/insurance/insurance-list.provider";
import { CompanyAccountPlanListProvider } from "../../../../../../../../shared/cw-backend/providers/financial/company-account-plan/company-account-plan-list.provider";
import { FilterListProvider } from "../../../../../../../../shared/cw-backend/providers/billing/filter/filter-list.provider";
import { BatchEntryListProvider } from "../../../../../../../../shared/cw-backend/providers/operational/operational/reception/batchentry/batchentry-list.provider";
import { DocumentModelListProvider } from "../../../../../../../../shared/cw-backend/providers/operational/tools/document-model/document-model-list.provider";
import { ProfessionalListProvider } from "../../../../../../../../shared/cw-backend/providers/organizational/professional/professional-list.provider";
import { PatientListProvider } from "../../../../../../../../shared/cw-backend/providers/register/operational/patient/patient-list.provider";
import { UserListProvider } from "../../../../../../../../shared/cw-backend/providers/security/user/user-list.provider";
import { TypeGuideListProvider } from "../../../../../../../../shared/cw-backend/providers/tiss/type-guide/type-guide-list.provider";
import { PageOptions } from "../../../../../../../../shared/cw-backend/util/page";
import { SnackBarService } from "../../../../../../../../shared/cw-utils/snackbar.service";

export interface ItemData {
    element: any;
    selected: boolean;
}
@Component({
    selector: "app-filter",
    templateUrl: "./filter.component.html",
    styleUrls: ["./filter.component.scss"],
    animations: [
        trigger("fadeInOut", [
            transition(":enter", [
                style({ opacity: 0 }),
                animate("200ms ease-in", style({ opacity: 1 })),
            ]),
            transition(":leave", [
                animate("200ms ease-out", style({ opacity: 0 })),
            ]),
        ]),
    ],
})
export class FilterComponent implements OnInit {
    //Retorno dos tipos de filtros existentes e entrada de dados
    @Input("entity") entity: any;
    @Input("lastFilter") lastFilter: boolean = false;
    @Input("entityFilter") entityFilter = Array();
    @Input("scope") scope: string;
    @Output("filterValues") filterValues = new EventEmitter();
    @Output("statusCurrent") statusCurrent = new EventEmitter();

    //variables
    documentTypeControl = new FormControl();
    insuranceControl = new FormControl();
    accountPlanReceivedControl = new FormControl();
    administratorControl = new FormControl();
    specialityControl = new FormControl();
    professionalControl = new FormControl();
    batchEntryControl = new FormControl();
    payTypeControl = new FormControl();
    filter = new Filter();
    statusFilter: string;
    lastBillingFilter: any;
    titleAdmninistrator: string = "Administrador";

    //list
    patientList = new Array<Patient>();
    groupList = new Array<Group>();
    filterTypes = new Array<Filter>();
    filteAndValues = new Array<Filter>();
    typeGuideList = new Array<TypeGuide>();
    exameTypeList = new Array<ExameType>();
    insuranceList = new Array<Insurance>();
    accountPlanReceivedList = new Array<CompanyAccountPlan>();
    administratorList = new Array<UserSimple>();
    specialityList = new Array<Professional>();
    professionalList = new Array<Professional>();
    batchEntryList = new Array<BatchEntry>();
    payTypeList = new Array<PayType>();

    documentTypeSelectd = new Array<ItemData>();
    insuranceSelectd = new Array<ItemData>();
    accountPlanReceivedSelectd = new Array<ItemData>();
    administratorSelectd = new Array<ItemData>();
    specialitySelectd = new Array<ItemData>();
    professionalSelectd = new Array<ItemData>();
    batchEntrySelectd = new Array<ItemData>();
    payTypeSelectd = new Array<ItemData>();

    readonly documentTypeList: Array<{ id: string; name: string }> = [
        { id: "1", name: "1" },
        { id: "2", name: "2" },
        { id: "3", name: "3" },
        { id: "4", name: "4" },
        { id: "X", name: "X" },
        { id: "R", name: "R" },
    ];

    /*
     *Controle de formulário do filtro período
     */
    rangeFilterForm: FormGroup;
    /*
     *Controle de formulário do filtro data de vencimento
     */
    rangeDueDateFilterForm: FormGroup;
    /*
     *Controle de formulário do filtro data de recebimento
     */
    rangeDatePayFilterForm: FormGroup;
    /*
     *Controle de formulário do filtro paciente
     */
    patientFilterForm: FormGroup;
    /*
     *Controle de formulário do filtro grupo
     */
    groupFilterForm: FormGroup;
    /*
     * Controle de formulário do filtro data
     */
    dateFilterForm: FormGroup;
    /*
     * controle de formulário filtro status
     */
    statusFilterForm: FormGroup;
    /*
     * controle de formulário filtro protocol status
     */
    protocolFilterStatus: FormGroup;
    /*
     * controle de formulário filtro protocol status saldo
     */
    protocolFilterBalanceStatus: FormGroup;
    /*
     * controle de formulário filtro somente convenios webservice
     */
    insuranceWebserviceForm: FormGroup;
    /*
     * controle de formulário filtro status autorização
     */
    statusAuthorizationForm: FormGroup;
    /*
     * controle de formulário filtro status paciente
     */
    statusPatientForm: FormGroup;
    /*
     * controle de formulário orderCuston status
     */
    statusOrderCustonForm: FormGroup;
    /*
     * controle de formulário tipo  de guia
     */
    typeGuideForm: FormGroup;
    /*
     * controle de formulário do filtro tipo de atendimento
     */
    exameTypeForm: FormGroup;
    /*
     * controle de formulário convênio
     */
    insuranceFilterForm: FormGroup;
    /*
     * controle de formulário plano de contas recebimentos
     */
    accountPlanReceivedFilterForm: FormGroup;
    /*
     * controle de formulário tipo de documento
     */
    documentTypeFilterForm: FormGroup;
    /*
     * controle de formulário Administrador
     */
    administratorFilterForm: FormGroup;
    /*
     * controle de formulário Speciality
     */
    specialityFilterForm: FormGroup;
    /*
     * controle de formulário professional
     */
    professionalFilterForm: FormGroup;
    /*
     * controle de formulário professional
     */
    batchEntryFilterForm: FormGroup;
    /*
     * controle de formulário professional
     */
    glossStatusFilterForm: FormGroup;
    /*
     * controle de formulário Faturar todas as unidades
     */
    billingAllUnitsFilterForm: FormGroup;
    /*
     * controle de formulário recorrente
     */
    recurrentFilterForm: FormGroup;
    /*
     * controle de formulário somente faturados
     */
    onlyBillingForm: FormGroup;
    /*
     * controle de formulário filtrar por data da OS
     */
    filterByOsDatedForm: FormGroup;
    /*
     * controle de formulário tipo de pagamento
     */
    payTypeFilterForm: FormGroup;

    /* pageSettings */
    patientPageOptions: PageOptions;
    groupPageOptions: PageOptions;
    insurancePageOptions: PageOptions;
    accountPlanReceivedPageOptions: PageOptions;
    administratorPageOptions: PageOptions;
    specialityPageOptions: PageOptions;
    professionalPageOptions: PageOptions;
    batchEntryPageOptions: PageOptions;
    payTypePageOptions: PageOptions;

    /*
     *controle de select para o convênio
     */
    rawDataInsurance: Array<ItemData> = [];
    selectDataInsurance: Array<ItemData> = [];
    /*
     *controle de select para o plano de contas recebimentos
     */
    rawDataAccuntPlanReceived: Array<ItemData> = [];
    selectDataAccountPlanReceived: Array<ItemData> = [];
    /*
     *controle de select para o administrator
     */
    rawDataAdministrator: Array<ItemData> = [];
    selectDataAdministrator: Array<ItemData> = [];
    /*
     *controle de select para o speciality
     */
    rawDataSpeciality: Array<ItemData> = [];
    selectDataSpeciality: Array<ItemData> = [];
    /*
     *controle de select para o professional
     */
    rawDataProfessional: Array<ItemData> = [];
    selectDataProfessional: Array<ItemData> = [];
    /*
     *controle de select para o professional
     */
    rawDataBatchEntry: Array<ItemData> = [];
    selectDataBatchEntry: Array<ItemData> = [];
    /*
        *controle de select para o tipo de pagamento
        */
    rawDataPayType: Array<ItemData> = [];
    selectDataPayType: Array<ItemData> = [];

    /*
     *controle de select para o tipo de documento
     */
    rawDataDocumentType: Array<ItemData> = [];
    selectDataDocumentType: Array<ItemData> = [];

    private _unsubscribeAll: Subject<any>;

    downloadAndSendStatus = [
        {
            name: "E-mail não enviado",
            status: "1",
        },
        {
            name: "E-mail enviado",
            status: "2",
        },
        {
            name: "Baixado",
            status: "3",
        },
        {
            name: "Não baixado",
            status: "4",
        },
    ];

    autorizationStatus = [
        {
            name: "Autorizado",
            status: "1",
        },
        {
            name: "Em Análise",
            status: "2",
        },
        {
            name: "Negado",
            status: "3",
        },
        {
            name: "Aguardando justificativa técnica do solicitante",
            status: "4",
        },
        {
            name: "Sem Autorização",
            status: "7",
        },
        {
            name: "Aguardando documentação do prestador",
            status: "5",
        },
        {
            name: "Solicitação cancelada",
            status: "6",
        },
        {
            name: "Autorizado parcialmente",
            status: "7",
        },
    ];

    statusPatientList = [
        {
            name: "Todos",
            status: "0",
        },
        {
            name: "Ativos",
            status: "1",
        },
        {
            name: "Inativos",
            status: "2",
        },
    ];

    paymentTypeEnumList: any[] = [
        {
            id: "1",
            name: "Dinheiro",
        },
        {
            id: "4",
            name: "Crédito",
        },
        {
            id: "3",
            name: "Débito",
        },
        {
            id: "2",
            name: "Cheque",
        },
        {
            id: "5",
            name: "Boleto Bancário",
        },
        {
            id: "6",
            name: "Promissória",
        },
        {
            id: "7",
            name: "Transferência Bancária",
        },
        {
            id: "8",
            name: "Pix",
        },
        {
            id: "9",
            name: "Outros",
        },
    ];

    constructor(
        private filterListProvider: FilterListProvider,
        private _formBuilder: FormBuilder,
        private patientListProvider: PatientListProvider,
        private groupListProvider: GroupListProvider,
        private typeGuideListProvider: TypeGuideListProvider,
        private attendanceListProvider: AttendanceListProvider,
        private insuranceListProvider: InsuranceListProvider,
        private companyAccountPlanListProvider: CompanyAccountPlanListProvider,
        private accountPlanListProvider: AccountPlanListProvider,
        private userListProvider: UserListProvider,
        private professionalListProvider: ProfessionalListProvider,
        private batchEntryListProvider: BatchEntryListProvider,
        private sendingToFinanceListProvider: SendingToFinanceListProvider,
        private documentModelListProvider: DocumentModelListProvider,
        private _snackBar: SnackBarService
    ) {
        this._unsubscribeAll = new Subject();
        this.patientPageOptions = new PageOptions();
        this.groupPageOptions = new PageOptions();
        this.insurancePageOptions = new PageOptions();
        this.accountPlanReceivedPageOptions = new PageOptions();
        this.administratorPageOptions = new PageOptions();
        this.specialityPageOptions = new PageOptions();
        this.professionalPageOptions = new PageOptions();
        this.batchEntryPageOptions = new PageOptions();
        this.batchEntryPageOptions.fieldSort = "opened";
        this.batchEntryPageOptions.sortDirection = "desc";
        this.payTypePageOptions = new PageOptions();
    }
    ngOnInit() {
        if (this.scope == "transfer") {
            this.statusFilter = "new";
        } else if (this.scope === "lotLaunch") {
            if (this.entity?.closed != null) {
                this.statusFilter = "edit";
                this.getBatchEntryFilter();
            } else {
                this.statusFilter = "new";
            }
        } else {
            this.statusFilter = this.entity?.id ? "edit" : "new";
        }

        if (this.scope == "sendingToFinance") {
            this.titleAdmninistrator = "Usuario";
            if (this.entity?.closed != null) {
                this.statusFilter = "edit";
                this.getSendingToFinanceFilter();
            } else {
                this.statusFilter = "new";
            }
        }

        // this.lastBillingFilter = JSON.parse(localStorage.getItem('last_filterBilling'));
        // if (this.lastBillingFilter) {
        //     this.billingFilter = this.lastBillingFilter.lastBillingFilter.filterList;
        //     this.lastFilter = true;
        // } else {
        //     this.lastFilter = false;
        // }

        this.getFilterList();
    }

    ngAfterViewInit() {
        setTimeout(() => {
            this.emitFilter();
        }, 2000);
    }

    /* buscar lista de filtros */
    getFilterList() {
        this.filterTypes = new Array();
        this.filterListProvider.getByScope(this.scope).then((res) => {
            this.filterTypes = res.body;
            this.lastFilter ? this.initForm("lastFilter") : this.initForm();
        });
    }

    getExameTypeList(value?) {
        this.attendanceListProvider
            .getExameTypeList()
            .then((res) => {
                this.exameTypeList = res.body;
                if (value !== undefined && value !== null && value !== "") {
                    const exameTypeId = value?.id ?? value;
                    const exameType = this.exameTypeList.find(
                        (type) => type.id == exameTypeId
                    );
                    this.exameTypeForm.controls["exameType"].setValue(
                        exameType ?? null,
                        { emitEvent: false }
                    );
                }
            })
            .catch((error) => {
                this._snackBar.unexpectedMessage(error?.status);
            });
    }

    /* buscar lista de pacientes */
    getPatientList() {
        this.patientPageOptions.fieldSort = "person.name";
        this.patientListProvider
            .getPageActive(this.patientPageOptions)
            .then((res) => {
                this.patientList = res.body.content;
            });
    }

    observableExameType() {
        this.exameTypeForm.valueChanges
            .pipe(
                takeUntil(this._unsubscribeAll),
                debounceTime(500),
                distinctUntilChanged()
            )
            .subscribe({
                next: () => {
                    this.emitFilter();
                },
            });
    }

    /* burcar forma de pagemento*/
    getPayTypeList() {
        this.payTypeList = this.paymentTypeEnumList;
        this.rawDataPayType = [];
        this.payTypeList.forEach((element) => {
            this.rawDataPayType.push({
                element: element,
                selected: this.checkSelected(element, "PAY_TYPE"),
            });
        });
    }

    getDocumentTypeList(filterText: string = "") {
        const term = (filterText ?? "").toString().trim().toLowerCase();
        this.rawDataDocumentType = [];

        this.documentModelListProvider
            .getTypeAll(
        ).then((res) => {
            console.log(res);
            res.body.values.forEach((element) => {
                this.rawDataDocumentType.push({
                    element,
                    selected: this.checkSelected(element, "DOCUMENT_TYPE"),
                });
            });
        });
    }

    setPaytypeSelected(payIdlist) {
        payIdlist?.forEach(element => {
            const index = this.payTypeList.findIndex(p => p.id == element);
            if (index >= 0) {
                let item: ItemData;
                item.element = this.payTypeList[index];
                item.selected = true;
                this.payTypeSelectd.push(
                    item
                )
            }

        });
        this.payTypeList.forEach
    }

    /* buscar lista de groupos */
    getGroupList() {
        this.groupPageOptions.fieldSort = "name";
        this.groupListProvider
            .getPageSimpleList(this.groupPageOptions)
            .then((res) => {
                this.groupList = res.body.content;
            });
    }

    // Get all typeGuides
    getTypeGuideList(value?) {
        this.typeGuideListProvider.getAll().then((res) => {
            this.typeGuideList = res.body;
            if (value) {
                const typeGuide = this.typeGuideList.filter(
                    (type) => type.id == value
                );
                this.typeGuideForm.controls["typeGuide"].setValue(typeGuide[0]);
            }
        });
    }

    // Get all typeGuides
    getBatchEntryList(value?) {
        this.batchEntryListProvider
            .getPageSimpleList(this.batchEntryPageOptions)
            .then((res) => {
                this.batchEntryList = res.body.content;
                this.rawDataBatchEntry = [];
                this.batchEntryList.forEach((element) => {
                    this.rawDataBatchEntry.push({
                        element: element,
                        selected: this.checkSelected(element, "BATCHENTRY"),
                    });
                });
            });
    }

    /* Buscar lista de convênios */
    getInsuranceList() {
        this.insurancePageOptions.fieldSort = "name";
        this.insuranceListProvider
            .getPageSimpleList(this.insurancePageOptions)
            .then((res) => {
                this.insuranceList = res.body.content;
                this.rawDataInsurance = [];
                this.insuranceList.forEach((element) => {
                    this.rawDataInsurance.push({
                        element: element,
                        selected: this.checkSelected(element, "INSURANCE"),
                    });
                });
            });
    }

    getInsuranceWebserviceList() {
        this.insurancePageOptions.fieldSort = "name";
        this.insuranceListProvider
            .getPageWebservice(this.insurancePageOptions)
            .then((res) => {
                this.insuranceList = res.body.content;
                this.rawDataInsurance = [];
                this.insuranceList.forEach((element) => {
                    this.rawDataInsurance.push({
                        element: element,
                        selected: this.checkSelected(element, "INSURANCE"),
                    });
                });
            });
    }

    async getInsuranceByMultipleIds(values: string) {
        let result = null;
        return new Promise((resolve, reject) => {
            let idList = values.split(",").map((v) => parseInt(v, 10));
            this.insuranceListProvider
                .getInsuranceByMultipleIds(idList)
                .then((res) => {
                    result = res.body;
                    resolve(result);
                })
                .catch((errt) => {
                    reject(result);
                });
        });
    }

    /* Buscar lista de planos de contas recebimentos */
    getAccountPlanReceivedList() {
        this.accountPlanReceivedPageOptions.fieldSort = "name";
        this.accountPlanListProvider
            .getAccountPlanType( this.scope === 'accounstReceivable'? "R" : "D", this.accountPlanReceivedPageOptions)
            .then((res) => {
                this.accountPlanReceivedList = res.body.content;
                this.rawDataAccuntPlanReceived = [];
                this.accountPlanReceivedList.forEach((element) => {
                    this.rawDataAccuntPlanReceived.push({
                        element: this.mapCompanyAccountPlanElement(element),
                        selected: this.checkSelected(
                            this.mapCompanyAccountPlanElement(element),
                            "ACCOUNT_PLAN_RECEIVED"
                        ),
                    });
                });
            });
    }

    mapCompanyAccountPlanElement(element: any) {
        return {
            ...element,
            name:
                element?.accountPlanName ||
                element?.accountPlan?.name ||
                element?.name,
        };
    }

   
    async getUserByMultipleIds(values: string) {
        let result = null;
        return new Promise((resolve, reject) => {
            let idList = values.split(",").map((v) => parseInt(v, 10));
            this.userListProvider
                .getUserByMultipleIds(idList)
                .then((res) => {
                    result = res.body;
                    resolve(result);
                })
                .catch((errt) => {
                    reject(result);
                });
        });
    }

    async getProfessionalAndEspecialistaByMultipleIds(values: string) {
        let result = null;
        return new Promise((resolve, reject) => {
            let idList = values.split(",").map((v) => parseInt(v, 10));
            this.professionalListProvider
                .getProfessionalByMultipleIdsAndType(idList, "I")
                .then((res) => {
                    result = res.body;
                    resolve(result);
                })
                .catch((errt) => {
                    reject(result);
                });
        });
    }

    /* Buscar lista de specialista */
    getSpecialistList() {
        this.specialityPageOptions.fieldSort = "person.name";
        this.professionalListProvider
            .getPage(this.specialityPageOptions, "I")
            .then((res) => {
                this.specialityList = res.body.content;
                this.rawDataSpeciality = [];
                this.specialityList.forEach((element) => {
                    this.rawDataSpeciality.push({
                        element: element,
                        selected: this.checkSelected(element, "SPECIALISTY"),
                    });
                });
            });
    }

    /* Buscar lista de profissional */
    getProfessionalList() {
        this.professionalPageOptions.fieldSort = "person.name";
        this.professionalListProvider
            .getSimplePage(this.professionalPageOptions, "I")
            .then((res) => {
                this.professionalList = res.body.content;
                this.rawDataProfessional = [];
                this.professionalList.forEach((element) => {
                    this.rawDataProfessional.push({
                        element: element,
                        selected: this.checkSelected(element, "PROFESSIONAL"),
                    });
                });
            });
    }

    /* Buscar lista de administrador */
    getAdministratorList() {
        this.administratorPageOptions.fieldSort = "person.name";
        this.userListProvider
            .getPageUserSimpleList(this.administratorPageOptions)
            .then((res) => {
                this.administratorList = res.body.content;
                this.rawDataAdministrator = [];
                this.administratorList.forEach((insurance) => {
                    this.rawDataAdministrator.push({
                        element: insurance,
                        selected: this.checkSelected(
                            insurance,
                            "ADMINISTRATOR"
                        ),
                    });
                });
            });
    }

    checkSelected(element: any, type): boolean {
        let result: number;
        switch (type) {
            case "DOCUMENT_TYPE":
                result = this.documentTypeSelectd.findIndex(
                    (item) => item.element.id == element.id
                );
                break;
            case "ADMINISTRATOR":
                result = this.administratorSelectd.findIndex(
                    (item) => item.element.id == element.id
                );
                break;
            case "SPECIALISTY":
                result = this.specialitySelectd.findIndex(
                    (item) => item.element.id == element.id
                );
                break;
            case "INSURANCE":
                result = this.insuranceSelectd.findIndex(
                    (item) => item.element.id == element.id
                );
                break;
            case "ACCOUNT_PLAN_RECEIVED":
                result = this.accountPlanReceivedSelectd.findIndex(
                    (item) => item.element.id == element.id
                );
                break;
            case "PROFESSIONAL":
                result = this.professionalSelectd.findIndex(
                    (item) => item.element.id == element.id
                );
                break;
                break;
            case "BATCHENTRY":
                result = this.batchEntrySelectd.findIndex(
                    (item) => item.element.id == element.id
                );
                break;
            case "PAY_TYPE":
                result = this.payTypeSelectd.findIndex(
                    (item) => item.element.id == element.id
                );
                break;

            default:
                break;
        }

        if (result == -1) {
            return false;
        } else {
            return true;
        }
    }

    /*
     *Buscar paciente por id
     */
    getPatientById(id) {
        if (!id) {
            return;
        }
        let patient;
        return new Promise((resolve, reject) => {
            this.patientListProvider.getById(id).subscribe({
                next: (res) => {
                    res ? resolve(res.body) : resolve(null);
                },
            });
        });
    }

    /*
     *Buscar  grupo por id
     */
    getGroupById(id) {
        if (!id) {
            return;
        }
        let group;
        return new Promise((resolve, reject) => {
            this.groupListProvider.get(id, null).subscribe({
                next: (res) => {
                    res ? resolve(res.body) : resolve(null);
                },
            });
        });
    }

    /*
     *  Controle de selecção dos convenios
     */
    optionClicked(event, data, type) {
        event.stopPropagation();
        this.toggleSelection(data, type);
    }

    toggleSelection(data: any, type: string) {
        data.selected = !data.selected;
        switch (type) {
            case "DOCUMENT_TYPE":
                if (data.selected === true) {
                    this.documentTypeSelectd.push(data);
                } else {
                    const i = this.documentTypeSelectd.findIndex(
                        (value) => value.element.id === data.element.id
                    );
                    this.documentTypeSelectd.splice(i, 1);
                }

                this.documentTypeFilterForm.controls["documentType"].setValue(
                    this.selectDataDocumentType
                );
                break;
            case "INSURANCE":
                if (data.selected === true) {
                    this.insuranceSelectd.push(data);
                } else {
                    const i = this.insuranceSelectd.findIndex(
                        (value) => value.element.id === data.element.id
                    );
                    this.insuranceSelectd.splice(i, 1);
                }

                this.insuranceFilterForm.controls["insurance"].setValue(
                    this.selectDataInsurance
                );
                break;

            case "ACCOUNT_PLAN_RECEIVED":
                if (data.selected === true) {
                    this.accountPlanReceivedSelectd.push(data);
                } else {
                    const i = this.accountPlanReceivedSelectd.findIndex(
                        (value) => value.element.id === data.element.id
                    );
                    this.accountPlanReceivedSelectd.splice(i, 1);
                }

                this.accountPlanReceivedFilterForm.controls[
                    "accountPlanReceived"
                ].setValue(this.selectDataAccountPlanReceived);
                break;

            case "ADMINISTRATOR":
                if (data.selected === true) {
                    this.administratorSelectd.push(data);
                } else {
                    const i = this.administratorSelectd.findIndex(
                        (value) => value.element.id === data.element.id
                    );
                    this.administratorSelectd.splice(i, 1);
                }

                this.administratorFilterForm.controls["administrator"].setValue(
                    this.selectDataAdministrator
                );
                break;

            case "SPECIALITY":
                if (data.selected === true) {
                    this.specialitySelectd.push(data);
                } else {
                    const i = this.specialitySelectd.findIndex(
                        (value) => value.element.id === data.element.id
                    );
                    this.specialitySelectd.splice(i, 1);
                }

                this.specialityFilterForm.controls["specialisty"].setValue(
                    this.selectDataSpeciality
                );
                break;

            case "PROFESSIONAL":
                if (data.selected === true) {
                    this.professionalSelectd.push(data);
                } else {
                    const i = this.professionalSelectd.findIndex(
                        (value) => value.element.id === data.element.id
                    );
                    this.professionalSelectd.splice(i, 1);
                }

                this.professionalFilterForm.controls["professional"].setValue(
                    this.selectDataProfessional
                );
                break;

            case "BATCHENTRY":
                if (data.selected === true) {
                    this.batchEntrySelectd.push(data);
                } else {
                    const i = this.batchEntrySelectd.findIndex(
                        (value) => value.element.id === data.element.id
                    );
                    this.batchEntrySelectd.splice(i, 1);
                }

                this.batchEntryFilterForm.controls["batchEntry"].setValue(
                    this.selectDataBatchEntry
                );
                break;
            case "PAY_TYPE":
                if (data.selected === true) {
                    this.payTypeSelectd.push(data);
                } else {
                    const i = this.payTypeSelectd.findIndex(
                        (value) => value.element.id === data.element.id
                    );
                    this.payTypeSelectd.splice(i, 1);
                }

                this.payTypeFilterForm.controls["payType"].setValue(
                    this.selectDataPayType
                );
                break;
            default:
                break;
        }

        this.emitFilter();
    }

    /*
     *Controle para remover os itens do combo
     */
    removeChip(data: ItemData, type) {
        this.toggleSelection(data, type);
        this.emitFilter();
    }

    ngOnDestroy(): void {
        this._unsubscribeAll.next(true);
        this._unsubscribeAll.complete();
    }

    /* inicia formularios */
    initForm(type?: string) {
        if (type === "addOrder") {
            this.statusFilter = "new";
            this.entityFilter.forEach((billFilter) => {
                this.removeFilter(billFilter.filter.key);
            });
            setTimeout(() => {
                this.initForm();
            }, 500);
        } else if (this.statusFilter === "edit" || type === "edit") {
            this.entityFilter.forEach((billFilter) => {
                this.createForm(billFilter.filter, billFilter.value);
            });
        } else if (type == "lastFilter") {
            this.entityFilter.forEach((billFilter) => {
                this.createForm(billFilter, billFilter.value);
            });
        } else {
            let lastFilter: any[] = JSON.parse(
                sessionStorage.getItem(`${this.scope}Filter`)
            );

            this.filterTypes.forEach((filterType) => {
                let filter: any;
                if (lastFilter != null && lastFilter.length > 0) {
                    filter = lastFilter.filter((f) => f.id == filterType.id)[0];
                }
                filterType.mandatory === true
                    ? this.createForm(filterType, filter?.value)
                    : "";
            });
            this.createDefaultSendingToFinancePeriodFilter(lastFilter);
        }
    }

    /* Funções para remover os filtros */
    removeFilter(type) {
        console.log("🚀 ~ FilterComponent ~ removeFilter ~ type:", type)
        switch (type) {
            case "patient":
                delete this.patientFilterForm;
                break;

            case "group":
                delete this.groupFilterForm;
                break;

            case "period":
                delete this.rangeFilterForm;
                break;

            case "rangeDueDate":
                delete this.rangeDueDateFilterForm;
                break;

            case "rangeDatePay":
                delete this.rangeDatePayFilterForm;
                break;

            case "dateLimit":
                delete this.dateFilterForm;
                break;

            case "Status":
                delete this.statusFilterForm;
                break;

            case "Status da Glosa":
                delete this.glossStatusFilterForm;
                break;

            case "typeGuide":
                delete this.typeGuideForm;
                break;

            case "exameType":
                delete this.exameTypeForm;
                break;

            case "insurance":
                delete this.insuranceFilterForm;
                break;

            case "ACCOUNT_PLAN_RECEIVED":
                delete this.accountPlanReceivedFilterForm;
                this.accountPlanReceivedSelectd = [];
                this.rawDataAccuntPlanReceived = [];
                this.selectDataAccountPlanReceived = [];
                this.accountPlanReceivedControl.setValue(null, {
                    emitEvent: false,
                });
                this.accountPlanReceivedControl.enable({ emitEvent: false });
                break;

            case "administrator":
                delete this.administratorFilterForm;
                break;

            case "speciality":
                delete this.specialityFilterForm;
                break;

            case "professional":
                delete this.professionalFilterForm;
                break;

            case "batchEntry":
                delete this.batchEntryFilterForm;
                break;
            case "statusPatient":
                delete this.statusPatientForm;
                break;
            case "billingAllUnitsForm":
                delete this.billingAllUnitsFilterForm;
                break;
            case "insuranceWebservice":
                delete this.insuranceWebserviceForm;
                break;
            case "recurrent":
                delete this.recurrentFilterForm;
                break;
            case "protocolStatus":
                delete this.protocolFilterStatus;
                break;
            case "protocolBalanceStatus":
                delete this.protocolFilterBalanceStatus;
                break;
            case "onlyBilling":
                delete this.onlyBillingForm;
                break;
            case "filterByOsDatedForm":
                delete this.filterByOsDatedForm;
                break;
            case "payType":
                delete this.payTypeFilterForm;
                break;
            case "DOCUMENT_TYPE":
                delete this.documentTypeFilterForm;
                this.documentTypeSelectd = [];
                this.rawDataDocumentType = [];
                this.selectDataDocumentType = [];
                this.documentTypeControl.setValue(null, { emitEvent: false });
                this.documentTypeControl.enable({ emitEvent: false });
                break;

            default:
                break;
        }

        this.emitFilter();
    }

    /*
     * campo dedicados a filtros  e a emisão de eventos
     */

    observableStatusFilter() {
        this.statusFilterForm.valueChanges
            .pipe(
                takeUntil(this._unsubscribeAll),
                debounceTime(500),
                distinctUntilChanged()
            )
            .subscribe({
                next: (result: any) => {
                    this.emitFilter();
                },
            });
    }
    observableInsuranceWebservice() {
        this.insuranceWebserviceForm.valueChanges
            .pipe(
                takeUntil(this._unsubscribeAll),
                debounceTime(500),
                distinctUntilChanged()
            )
            .subscribe({
                next: (result: any) => {
                    this.emitFilter();
                },
            });
    }

    observableGlossStatusFilter() {
        this.glossStatusFilterForm.valueChanges
            .pipe(
                takeUntil(this._unsubscribeAll),
                debounceTime(500),
                distinctUntilChanged()
            )
            .subscribe({
                next: (result: any) => {
                    this.emitFilter();
                },
            });
    }

    observableStatusAuthorization() {
        this.statusAuthorizationForm.valueChanges
            .pipe(
                takeUntil(this._unsubscribeAll),
                debounceTime(500),
                distinctUntilChanged()
            )
            .subscribe({
                next: (result: any) => {
                    this.emitFilter();
                },
            });
    }

    observableStatusPatient() {
        this.statusPatientForm.valueChanges
            .pipe(
                takeUntil(this._unsubscribeAll),
                debounceTime(500),
                distinctUntilChanged()
            )
            .subscribe({
                next: (result: any) => {
                    this.emitFilter();
                },
            });
    }

    observableStatusOrderCustonForm() {
        this.statusOrderCustonForm.valueChanges
            .pipe(
                takeUntil(this._unsubscribeAll),
                debounceTime(500),
                distinctUntilChanged()
            )
            .subscribe({
                next: (result: any) => {
                    this.emitFilter();
                },
            });
    }

    observableRangeFilter() {
        this.rangeFilterForm.valueChanges
            .pipe(
                takeUntil(this._unsubscribeAll),
                debounceTime(500),
                distinctUntilChanged()
            )
            .subscribe({
                next: (result: any) => {
                    this.emitFilter();
                },
            });
    }

    observableRangeDueDateFilter() {
        this.rangeDueDateFilterForm.valueChanges
            .pipe(
                takeUntil(this._unsubscribeAll),
                debounceTime(500),
                distinctUntilChanged()
            )
            .subscribe({
                next: (result: any) => {
                    this.emitFilter();
                },
            });
    }

    observableRangeDatePayFilter() {
        this.rangeDatePayFilterForm.valueChanges
            .pipe(
                takeUntil(this._unsubscribeAll),
                debounceTime(500),
                distinctUntilChanged()
            )
            .subscribe({
                next: (result: any) => {
                    this.emitFilter();
                },
            });
    }

    observableTypeGuide() {
        this.typeGuideForm.valueChanges
            .pipe(
                takeUntil(this._unsubscribeAll),
                debounceTime(500),
                distinctUntilChanged()
            )
            .subscribe({
                next: (result: any) => {
                    this.emitFilter();
                },
            });
    }

    observableDateFilter() {
        this.dateFilterForm.valueChanges
            .pipe(
                takeUntil(this._unsubscribeAll),
                debounceTime(500),
                distinctUntilChanged()
            )
            .subscribe({
                next: (result: any) => {
                    this.emitFilter();
                },
            });
    }

    observableBatchEntryilter() {
        this.batchEntryFilterForm.valueChanges
            .pipe(
                takeUntil(this._unsubscribeAll),
                debounceTime(500),
                distinctUntilChanged()
            )
            .subscribe({
                next: (result: any) => {
                    this.emitFilter();
                },
            });
    }

    observablePatientFilter() {
        this.patientFilterForm.valueChanges
            .pipe(
                takeUntil(this._unsubscribeAll),
                debounceTime(500),
                distinctUntilChanged()
            )
            .subscribe({
                next: (res: any) => {
                    if (res.patient && res.patient.person) {
                        this.emitFilter();
                        //this.patientPgaeOptions.argument = res.patient.person;
                    } else if (res) {
                        this.patientPageOptions.argument = res.patient;
                    } else {
                        this.patientPageOptions.argument = "";
                        this.patientFilterForm.controls["patient"].setValue(
                            null
                        );
                    }
                    this.getPatientList();
                },
            });
    }

    observablePayTypeFilter() {
        this.payTypeFilterForm.valueChanges
            .pipe(
                takeUntil(this._unsubscribeAll),
                debounceTime(500),
                distinctUntilChanged()
            )
            .subscribe({
                next: (res: any) => {
                    let filter = "";
                    if (res.id) {
                        this.emitFilter();
                    } else if (typeof res === "string") {
                        filter = res
                    }

                    this.payTypePageOptions.argument = filter;
                    this.getPayTypeList();
                },
            });
    }

    observableDocumentType() {
        this.documentTypeControl.valueChanges
            .pipe(
                takeUntil(this._unsubscribeAll),
                debounceTime(500),
                distinctUntilChanged()
            )
            .subscribe({
                next: (res) => {
                    const filterText = res && typeof res === "string" ? res : "";
                    this.getDocumentTypeList(filterText);
                },
            });
    }

    observableGroupFilter() {
        this.groupFilterForm.valueChanges
            .pipe(
                takeUntil(this._unsubscribeAll),
                debounceTime(500),
                distinctUntilChanged()
            )
            .subscribe({
                next: (res: any) => {
                    let filter = "";

                    if (res?.group?.name) {
                        this.emitFilter();
                        filter = res?.group?.name;
                    } else if (typeof res.group === "string") {
                        filter = res?.group;
                    } else {
                        this.groupFilterForm.controls["group"].setValue(null);
                    }
                    this.groupPageOptions.argument = filter;
                    this.getGroupList();
                },
            });
    }

    observableInsurance() {
        this.insuranceControl.valueChanges
            .pipe(
                takeUntil(this._unsubscribeAll),
                debounceTime(500),
                distinctUntilChanged()
            )
            .subscribe({
                next: (res) => {
                    if (res && typeof res === "string") {
                        this.insurancePageOptions.argument = res;
                    } else {
                        this.insurancePageOptions.argument = "";
                    }
                    // if (this.scope === 'AUTHORIZATION') {
                    //     this.getInsuranceWebserviceList();
                    // } else {
                    this.getInsuranceList();
                    // }
                },
            });
    }

    observableAccountPlanReceived() {
        this.accountPlanReceivedControl.valueChanges
            .pipe(
                takeUntil(this._unsubscribeAll),
                debounceTime(500),
                distinctUntilChanged()
            )
            .subscribe({
                next: (res) => {
                    if (res && typeof res === "string") {
                        this.accountPlanReceivedPageOptions.argument = res;
                    } else {
                        this.accountPlanReceivedPageOptions.argument = "";
                    }
                    this.getAccountPlanReceivedList();
                },
            });
    }

    observableSpecialisty() {
        this.specialityControl.valueChanges
            .pipe(
                takeUntil(this._unsubscribeAll),
                debounceTime(500),
                distinctUntilChanged()
            )
            .subscribe({
                next: (res) => {
                    if (res && typeof res === "string") {
                        this.specialityPageOptions.argument = res;
                    } else {
                        this.specialityPageOptions.argument = "";
                    }
                    this.getSpecialistList();
                },
            });
    }

    observableProfessional() {
        this.professionalControl.valueChanges
            .pipe(
                takeUntil(this._unsubscribeAll),
                debounceTime(500),
                distinctUntilChanged()
            )
            .subscribe({
                next: (res) => {
                    if (res && typeof res === "string") {
                        this.professionalPageOptions.argument = res;
                    } else {
                        this.professionalPageOptions.argument = "";
                    }
                    this.getProfessionalList();
                },
            });
    }
    observableBatchEntry() {
        this.batchEntryControl.valueChanges
            .pipe(
                takeUntil(this._unsubscribeAll),
                debounceTime(500),
                distinctUntilChanged()
            )
            .subscribe({
                next: (res) => {
                    if (res && typeof res === "string") {
                        this.batchEntryPageOptions.argument = res;
                    } else {
                        this.batchEntryPageOptions.argument = "";
                    }
                    this.getBatchEntryList();
                },
            });
    }

    observableBillingAllUnits() {
        this.billingAllUnitsFilterForm.valueChanges
            .pipe(
                takeUntil(this._unsubscribeAll),
                debounceTime(500),
                distinctUntilChanged()
            )
            .subscribe({
                next: (res) => { },
            });
    }

    observableAdministrator() {
        this.administratorControl.valueChanges
            .pipe(
                takeUntil(this._unsubscribeAll),
                debounceTime(500),
                distinctUntilChanged()
            )
            .subscribe({
                next: (res) => {
                    if (res && typeof res === "string") {
                        this.administratorPageOptions.argument = res;
                    } else {
                        this.administratorPageOptions.argument = "";
                    }
                    this.getAdministratorList();
                },
            });
    }

    observableRecurrentFilter() {
        if (this.recurrentFilterForm) {
            this.recurrentFilterForm.valueChanges
                .pipe(
                    debounceTime(300),
                    distinctUntilChanged(),
                    takeUntil(this._unsubscribeAll)
                )
                .subscribe(() => {
                    this.emitFilter();
                });
        }
    }

    observableOnlyBillingFilter() {
        if (this.onlyBillingForm) {
            this.onlyBillingForm.valueChanges
                .pipe(
                    debounceTime(300),
                    distinctUntilChanged(),
                    takeUntil(this._unsubscribeAll)
                )
                .subscribe(() => {
                    this.emitFilter();
                });
        }
    }

    observableFilterByOsDated() {
        if (this.filterByOsDatedForm) {
            this.filterByOsDatedForm.valueChanges
                .pipe(
                    debounceTime(300),
                    distinctUntilChanged(),
                    takeUntil(this._unsubscribeAll)
                )
                .subscribe(() => {
                    this.emitFilter();
                });
        }
    }

    observableProtocolFilterStatus() {
        this.protocolFilterStatus.valueChanges
            .pipe(
                takeUntil(this._unsubscribeAll),
                debounceTime(500),
                distinctUntilChanged()
            )
            .subscribe({
                next: (result: any) => {
                    this.emitFilter();
                },
            });
    }

    observableProtocolFilterBalanceStatus() {
        this.protocolFilterBalanceStatus.valueChanges
            .pipe(
                takeUntil(this._unsubscribeAll),
                debounceTime(500),
                distinctUntilChanged()
            )
            .subscribe({
                next: (result: any) => {
                    this.emitFilter();
                },
            });
    }

    /*
     *cria o formulario de acordo com o filtro escolhido na tela
     */
    async createForm(filterType: Filter, value?: any) {
        switch (filterType.key) {
            case "Periodo":
                if (this.rangeFilterForm instanceof FormGroup) {
                    this._snackBar.warnMessage("Filtro já Selecionado!");
                    return;
                }
                if (this.dateFilterForm instanceof FormGroup) {
                    delete this.dateFilterForm;
                }
                const periodValue = this.getDefaultSendingToFinancePeriodValue(value);
                const period = periodValue ? periodValue.split(",") : null;

                this.rangeFilterForm = this._formBuilder.group({
                    filter: filterType,
                    start: [period ? period[0] : null, Validators.required],
                    end: [period ? period[1] : null, Validators.required],
                });
                this.statusFilter === "new"
                    ? this.enableForm(this.rangeFilterForm)
                    : this.disableForm(this.rangeFilterForm);
                this.observableRangeFilter();
                break;

            case "Status":
                if (this.statusFilterForm instanceof FormGroup) {
                    this._snackBar.warnMessage("Filtro já Selecionado!");
                    return;
                }
                this.statusFilterForm = this._formBuilder.group({
                    filter: filterType,
                    status: [
                        value
                            ? value
                            : filterType.value
                                ? filterType.value
                                : "3",
                        Validators.required,
                    ],
                });
                this.statusFilter === "new"
                    ? this.enableForm(this.statusFilterForm)
                    : this.disableForm(this.statusFilterForm);
                this.observableStatusFilter();
                break;

            case "FILTER_INSURANCE_WEBSERVICE":
                if (this.insuranceWebserviceForm instanceof FormGroup) {
                    this._snackBar.warnMessage("Filtro já Selecionado!");
                    return;
                }

                this.insuranceWebserviceForm = this._formBuilder.group({
                    filter: filterType,
                    status: [value ? value : true],
                });
                this.statusFilter === "new"
                    ? this.enableForm(this.insuranceWebserviceForm)
                    : this.disableForm(this.insuranceWebserviceForm);
                this.observableInsuranceWebservice();
                break;

            case "Status da Glosa":
                if (this.glossStatusFilterForm instanceof FormGroup) {
                    this._snackBar.warnMessage("Filtro já Selecionado!");
                    return;
                }

                this.glossStatusFilterForm = this._formBuilder.group({
                    filter: filterType,
                    status: [value ? value : "T", Validators.required],
                });
                this.statusFilter === "new"
                    ? this.enableForm(this.glossStatusFilterForm)
                    : this.disableForm(this.glossStatusFilterForm);
                this.observableGlossStatusFilter();
                break;

            case "Status Authorization":
                if (this.statusAuthorizationForm instanceof FormGroup) {
                    this._snackBar.warnMessage("Filtro já Selecionado!");
                    return;
                }

                this.statusAuthorizationForm = this._formBuilder.group({
                    filter: filterType,
                    status: [value ? value : ""],
                });
                this.statusFilter === "new"
                    ? this.enableForm(this.statusAuthorizationForm)
                    : this.disableForm(this.statusAuthorizationForm);
                this.observableStatusAuthorization();
                break;
            case "Status Paciente":
                if (this.statusPatientForm instanceof FormGroup) {
                    this._snackBar.warnMessage("Filtro já Selecionado!");
                    return;
                }

                let valueStandart = {
                    name: "Ativos",
                    status: "1",
                };

                this.statusPatientForm = this._formBuilder.group({
                    filter: filterType,
                    status: [value ? value : valueStandart],
                });
                this.statusFilter === "new"
                    ? this.enableForm(this.statusPatientForm)
                    : this.disableForm(this.statusPatientForm);
                this.observableStatusPatient();
                break;
            case "STATUS_ORDER_CUSTON":
                if (this.statusOrderCustonForm instanceof FormGroup) {
                    this._snackBar.warnMessage("Filtro já Selecionado!");
                    return;
                }

                this.statusOrderCustonForm = this._formBuilder.group({
                    filter: filterType,
                    status: [value ? value : ""],
                });
                this.statusFilter === "new"
                    ? this.enableForm(this.statusOrderCustonForm)
                    : this.disableForm(this.statusOrderCustonForm);
                this.observableStatusOrderCustonForm();
                break;

            case "Data Limite":
                if (this.dateFilterForm instanceof FormGroup) {
                    this._snackBar.warnMessage("Filtro já Selecionado!");
                    return;
                }
                if (this.rangeFilterForm instanceof FormGroup) {
                    delete this.rangeFilterForm;
                }
                this.dateFilterForm = this._formBuilder.group({
                    filter: filterType,
                    date: [
                        value ? moment(value) : moment(),
                        Validators.required,
                    ],
                });
                this.statusFilter === "new"
                    ? this.enableForm(this.dateFilterForm)
                    : this.disableForm(this.dateFilterForm);

                this.observableDateFilter();
                break;

            case "DUE_DATE":
                if (this.rangeDueDateFilterForm instanceof FormGroup) {
                    this._snackBar.warnMessage("Filtro já Selecionado!");
                    return;
                }
                const dueDatePeriod = value ? value.split(",") : null;

                this.rangeDueDateFilterForm = this._formBuilder.group({
                    filter: filterType,
                    start: [
                        dueDatePeriod ? dueDatePeriod[0] : null,
                        Validators.required,
                    ],
                    end: [
                        dueDatePeriod ? dueDatePeriod[1] : null,
                        Validators.required,
                    ],
                });
                this.statusFilter === "new"
                    ? this.enableForm(this.rangeDueDateFilterForm)
                    : this.disableForm(this.rangeDueDateFilterForm);
                this.observableRangeDueDateFilter();
                break;

            case "PAY_DATE":
                if (this.rangeDatePayFilterForm instanceof FormGroup) {
                    this._snackBar.warnMessage("Filtro já Selecionado!");
                    return;
                }
                const payDatePeriod = value ? value.split(",") : null;

                this.rangeDatePayFilterForm = this._formBuilder.group({
                    filter: filterType,
                    start: [
                        payDatePeriod ? payDatePeriod[0] : null,
                        Validators.required,
                    ],
                    end: [
                        payDatePeriod ? payDatePeriod[1] : null,
                        Validators.required,
                    ],
                });
                this.statusFilter === "new"
                    ? this.enableForm(this.rangeDatePayFilterForm)
                    : this.disableForm(this.rangeDatePayFilterForm);
                this.observableRangeDatePayFilter();
                break;

            case "Tipo de Guia":
                if (this.typeGuideForm instanceof FormGroup) {
                    this._snackBar.warnMessage("Filtro já Selecionado!");
                    return;
                }
                this.getTypeGuideList(value);
                this.typeGuideForm = this._formBuilder.group({
                    filter: filterType,
                    typeGuide: [value ? value : "", Validators.required],
                });
                this.statusFilter === "new"
                    ? this.enableForm(this.typeGuideForm)
                    : this.disableForm(this.typeGuideForm);
                this.observableTypeGuide();
                break;

            case "Tipo de Atendimento":
                if (this.exameTypeForm instanceof FormGroup) {
                    this._snackBar.warnMessage("Filtro já Selecionado!");
                    return;
                }
                this.exameTypeForm = this._formBuilder.group({
                    filter: filterType,
                    exameType: [null, Validators.required],
                });
                this.getExameTypeList(value);
                this.statusFilter === "new"
                    ? this.enableForm(this.exameTypeForm)
                    : this.disableForm(this.exameTypeForm);
                this.observableExameType();
                break;

            case "Paciente":
                if (this.patientFilterForm instanceof FormGroup) {
                    this._snackBar.warnMessage("Filtro já Selecionado!");
                    return;
                }

                this.getPatientList();

                value = await this.getPatientById(value);
                this.patientFilterForm = this._formBuilder.group({
                    filter: filterType,
                    patient: [value ? value : "", Validators.required],
                });
                this.statusFilter === "new"
                    ? this.enableForm(this.patientFilterForm)
                    : this.disableForm(this.patientFilterForm);
                this.observablePatientFilter();
                break;

            case "PAY_TYPE":
                if (this.payTypeFilterForm instanceof FormGroup) {
                    this._snackBar.warnMessage("Filtro já Selecionado!");
                    return;
                }

                this.getPayTypeList();
                this.setPaytypeSelected(filterType.value)
                // value = await this.getPatientById(value);
                this.payTypeFilterForm = this._formBuilder.group({
                    filter: filterType,
                    payType: [value ? value : "", Validators.required],
                });
                this.statusFilter === "new"
                    ? this.enableForm(this.payTypeFilterForm)
                    : this.disableForm(this.payTypeFilterForm);
                this.observablePayTypeFilter();
                break;

            case "DOCUMENT_TYPE":
                if (this.documentTypeFilterForm instanceof FormGroup) {
                    this._snackBar.warnMessage("Filtro já Selecionado!");
                    return;
                }

                this.getDocumentTypeList();

                if (value) {
                    const ids = value
                        .toString()
                        .split(",")
                        .map((v) => String(v).trim())
                        .filter((v) => v !== "");

                    if (ids.length > 0) {
                        ids.forEach((id) => {
                            const found = this.documentTypeList.find(
                                (dt) => dt.id === id
                            );
                            if (found) {
                                this.documentTypeSelectd.push({
                                    element: found,
                                    selected: true,
                                });
                            }
                        });
                    }
                }

                this.documentTypeFilterForm = this._formBuilder.group({
                    filter: filterType,
                    documentType: [
                        this.documentTypeSelectd.length > 0
                            ? this.documentTypeSelectd.map((x) => x.element)
                            : "",
                        Validators.required,
                    ],
                });

                if (this.statusFilter === "edit") {
                    this.disableForm(this.documentTypeFilterForm);
                    this.documentTypeControl.disable();
                }
                this.observableDocumentType();
                break;

            case "GROUP":
                if (this.groupFilterForm instanceof FormGroup) {
                    this._snackBar.warnMessage("Filtro já Selecionado!");
                    return;
                }

                this.getGroupList();

                value = await this.getGroupById(value);
                this.groupFilterForm = this._formBuilder.group({
                    filter: filterType,
                    group: [value ? value : "", Validators.required],
                });
                this.statusFilter === "new"
                    ? this.enableForm(this.groupFilterForm)
                    : this.disableForm(this.groupFilterForm);
                this.observableGroupFilter();
                break;

            case "Convênio":
                if (this.insuranceFilterForm instanceof FormGroup) {
                    this._snackBar.warnMessage("Filtro já Selecionado!");
                    return;
                }
                // if (this.scope === 'AUTHORIZATION') {
                //     this.getInsuranceWebserviceList();
                // } else {
                this.getInsuranceList();
                // }

                if (value) {
                    value = await this.getInsuranceByMultipleIds(value);
                }
                if (value?.length > 0) {
                    value.forEach((element) => {
                        let itemdata = {
                            element: element,
                            selected: true,
                        };
                        this.insuranceSelectd.push(itemdata);
                    });
                } else {
                    value = null;
                }
                this.insuranceFilterForm = this._formBuilder.group({
                    filter: filterType,
                    insurance: [value ? value : "", Validators.required],
                });
                if (this.statusFilter === "edit") {
                    this.disableForm(this.insuranceFilterForm);
                    this.insuranceControl.disable();
                }
                this.observableInsurance();
                break;

            case "ACCOUNT_PLAN_RECEIVED":
                if (this.accountPlanReceivedFilterForm instanceof FormGroup) {
                    this._snackBar.warnMessage("Filtro já Selecionado!");
                    return;
                }

                this.getAccountPlanReceivedList();

               
                    value = null;
                
                this.accountPlanReceivedFilterForm = this._formBuilder.group({
                    filter: filterType,
                    accountPlanReceived: [
                        value ? value : "",
                        Validators.required,
                    ],
                });
                if (this.statusFilter === "edit") {
                    this.disableForm(this.accountPlanReceivedFilterForm);
                    this.accountPlanReceivedControl.disable();
                }
                this.observableAccountPlanReceived();
                break;

            case "Administrador":
                if (this.administratorFilterForm instanceof FormGroup) {
                    this._snackBar.warnMessage("Filtro já Selecionado!");
                    return;
                }
                this.getAdministratorList();
                if (value) {
                    value = await this.getUserByMultipleIds(value);
                }
                if (value?.length > 0) {
                    value.forEach((element) => {
                        let itemdata = {
                            element: element,
                            selected: true,
                        };
                        this.administratorSelectd.push(itemdata);
                    });
                } else {
                    value = null;
                }
                this.administratorFilterForm = this._formBuilder.group({
                    filter: filterType,
                    administrator: [value ? value : "", Validators.required],
                });
                if (this.statusFilter === "edit") {
                    this.disableForm(this.administratorFilterForm);
                    this.administratorControl.disable();
                }

                this.observableAdministrator();
                break;

            case "Especialista":
                if (this.specialityFilterForm instanceof FormGroup) {
                    this._snackBar.warnMessage("Filtro já Selecionado!");
                    return;
                }
                this.getSpecialistList();
                if (value) {
                    value =
                        await this.getProfessionalAndEspecialistaByMultipleIds(
                            value
                        );
                }
                if (value?.length > 0) {
                    value.forEach((element) => {
                        let itemdata = {
                            element: element,
                            selected: true,
                        };
                        this.specialitySelectd.push(itemdata);
                    });
                } else {
                    value = null;
                }
                this.specialityFilterForm = this._formBuilder.group({
                    filter: filterType,
                    specialisty: [value ? value : "", Validators.required],
                });
                if (this.statusFilter === "edit") {
                    this.disableForm(this.specialityFilterForm);
                    this.specialityControl.disable();
                }
                this.observableSpecialisty();
                break;

            case "PROFESSIONAL":
                if (this.professionalFilterForm instanceof FormGroup) {
                    this._snackBar.warnMessage("Filtro já Selecionado!");
                    return;
                }
                this.getProfessionalList();
                if (value) {
                    value =
                        await this.getProfessionalAndEspecialistaByMultipleIds(
                            value
                        );
                }
                if (value?.length > 0) {
                    value.forEach((element) => {
                        let itemdata = {
                            element: element,
                            selected: true,
                        };
                        this.professionalSelectd.push(itemdata);
                    });
                } else {
                    value = null;
                }
                this.professionalFilterForm = this._formBuilder.group({
                    filter: filterType,
                    professional: [value ? value : "", Validators.required],
                });
                if (this.statusFilter === "edit") {
                    this.disableForm(this.professionalFilterForm);
                    this.professionalControl.disable();
                }
                this.observableProfessional();
                break;

            case "BATCH_ENTRY":
                if (this.batchEntryFilterForm instanceof FormGroup) {
                    this._snackBar.warnMessage("Filtro já Selecionado!");
                    return;
                }
                this.getBatchEntryList();
                if (value) {
                    // value = await this.getProfessionalAndEspecialistaByMultipleIds(value);
                }
                if (value?.length > 0) {
                    value.forEach((element) => {
                        let itemdata = {
                            element: element,
                            selected: true,
                        };
                        this.batchEntrySelectd.push(itemdata);
                    });
                } else {
                    value = null;
                }
                this.batchEntryFilterForm = this._formBuilder.group({
                    filter: filterType,
                    batchEntry: [value ? value : "", Validators.required],
                });
                if (this.statusFilter === "edit") {
                    this.disableForm(this.batchEntryFilterForm);
                    this.batchEntryControl.disable();
                }
                this.observableBatchEntry();
                break;
            case "BILLING_ALL_UNITS":
                if (this.billingAllUnitsFilterForm instanceof FormGroup) {
                    this._snackBar.warnMessage("Filtro já Selecionado!");
                    return;
                }

                this.billingAllUnitsFilterForm = this._formBuilder.group({
                    filter: filterType,
                    billingAllUnits: [
                        this.checkValue(value),
                        Validators.required,
                    ],
                });
                if (this.statusFilter === "edit") {
                    this.disableForm(this.billingAllUnitsFilterForm);
                    this.billingAllUnitsFilterForm.disable();
                }
                this.observableBillingAllUnits();
                break;

            case "RECURRENT":
                if (this.recurrentFilterForm instanceof FormGroup) {
                    this._snackBar.warnMessage("Filtro já Selecionado!");
                    return;
                }
                this.recurrentFilterForm = this._formBuilder.group({
                    filter: filterType,
                    recurrent: [value && value == "1" ? true : false],
                });
                this.statusFilter === "new"
                    ? this.enableForm(this.recurrentFilterForm)
                    : this.disableForm(this.recurrentFilterForm);
                this.observableRecurrentFilter();
                break;

            case "ONLY_BILLING":
                if (this.onlyBillingForm instanceof FormGroup) {
                    this._snackBar.warnMessage("Filtro já Selecionado!");
                    return;
                }
                this.onlyBillingForm = this._formBuilder.group({
                    filter: filterType,
                    status: [value && value == "1" ? true : true],
                });
                this.statusFilter === "new"
                    ? this.enableForm(this.onlyBillingForm)
                    : this.disableForm(this.onlyBillingForm);
                this.observableOnlyBillingFilter();
                break;

            case "FILTER_BY_OS_DATED":
                if (this.filterByOsDatedForm instanceof FormGroup) {
                    this._snackBar.warnMessage("Filtro já Selecionado!");
                    return;
                }
                this.filterByOsDatedForm = this._formBuilder.group({
                    filter: filterType,
                    status: [value && value == "1" ? true : true],
                });
                this.statusFilter === "new"
                    ? this.enableForm(this.filterByOsDatedForm)
                    : this.disableForm(this.filterByOsDatedForm);
                this.observableFilterByOsDated();
                break;

            case "PROTOCOL_STATUS":
                console.log("AQUI");
                if (this.protocolFilterStatus instanceof FormGroup) {
                    this._snackBar.warnMessage("Filtro já Selecionado!");
                    return;
                }
                this.protocolFilterStatus = this._formBuilder.group({
                    filter: filterType,
                    status: [value ? value : "ALL", Validators.required],
                });
                this.statusFilter === "new"
                    ? this.enableForm(this.protocolFilterStatus)
                    : this.disableForm(this.protocolFilterStatus);
                this.observableProtocolFilterStatus();
                break;

            case "PROTOCOL_BALANCE_STATUS":
                if (this.protocolFilterBalanceStatus instanceof FormGroup) {
                    this._snackBar.warnMessage("Filtro já Selecionado!");
                    return;
                }
                this.protocolFilterBalanceStatus = this._formBuilder.group({
                    filter: filterType,
                    status: [value ? value : "ALL", Validators.required],
                });
                this.statusFilter === "new"
                    ? this.enableForm(this.protocolFilterBalanceStatus)
                    : this.disableForm(this.protocolFilterBalanceStatus);
                this.observableProtocolFilterBalanceStatus();
                break;

            default:
                break;
        }
        this.emitFilter();
    }

    private createDefaultSendingToFinancePeriodFilter(lastFilter?: any[]): void {
        if (
            this.scope !== "sendingToFinance" ||
            this.rangeFilterForm instanceof FormGroup
        ) {
            return;
        }

        const periodFilter = this.filterTypes.find(
            (filterType) => filterType.key === "Periodo"
        );

        if (!periodFilter) {
            return;
        }

        const filter = lastFilter?.filter((f) => f.id == periodFilter.id)[0];
        this.createForm(periodFilter, filter?.value);
    }

    private getDefaultSendingToFinancePeriodValue(value?: any): any {
        if (
            this.scope !== "sendingToFinance" ||
            this.statusFilter !== "new" ||
            (value != null && value !== "")
        ) {
            return value;
        }

        const today = moment().format("yyyy-MM-DD");
        return `${today},${today}`;
    }

    checkValue(value: any): any {
        if (typeof value === "string") {
            if (value === "true") {
                return true;
            }
            if (value === "false") {
                return false;
            }
        } else {
            return true;
        }

        return true;
    }

    disableForm(form: FormGroup) {
        form.disable();
    }

    enableForm(form: FormGroup) {
        form.enable();
    }

    //Verifica se o formularios está instanciado e faz a tratativa para manda para o component Billing
    emitFilter(event?: any) {
       
        this.filteAndValues = new Array<any>();
        let filterLocalStorage = new Array<any>();

        if (this.groupFilterForm instanceof FormGroup) {
            let filter = this.groupFilterForm.getRawValue();
            filter.filter.value = filter.group.id;
            delete filter.group;
            this.filteAndValues.push(filter.filter);
        }

        if (this.patientFilterForm instanceof FormGroup) {
            let filter = this.patientFilterForm.getRawValue();
            filterLocalStorage.push(filter.filter);
            filter.filter.value = filter.patient.id;
            delete filter.patient;
            this.filteAndValues.push(filter.filter);
        }

        if (this.insuranceFilterForm instanceof FormGroup) {
            let filter = this.insuranceFilterForm.getRawValue();
            let insuranceIdList = new Array<String>();
            if (this.insuranceSelectd.length > 0) {
                this.insuranceSelectd.forEach((item) => {
                    insuranceIdList.push(String(item.element.id));
                });
                filter.filter.value = insuranceIdList.toString();
                delete filter.insurance;
                this.filteAndValues.push(filter.filter);
            }
        }

        if (this.accountPlanReceivedFilterForm instanceof FormGroup) {
            let filter = this.accountPlanReceivedFilterForm.getRawValue();
            let accountPlanReceivedIdList = new Array<String>();
            if (this.accountPlanReceivedSelectd.length > 0) {
                this.accountPlanReceivedSelectd.forEach((item) => {
                    accountPlanReceivedIdList.push(String(item.element.id));
                });
                filter.filter.value = accountPlanReceivedIdList.toString();
                filterLocalStorage.push(filter.filter);
                delete filter.accountPlanReceived;
                this.filteAndValues.push(filter.filter);
            }
        }

        if (this.administratorFilterForm instanceof FormGroup) {
            let filter = this.administratorFilterForm.getRawValue();
            let administratorIdList = new Array<String>();
            if (this.administratorSelectd.length > 0) {
                this.administratorSelectd.forEach((item) => {
                    administratorIdList.push(String(item.element.id));
                });
                filter.filter.value = administratorIdList.toString();
                delete filter.administrator;
                this.filteAndValues.push(filter.filter);
            }
        }

        if (this.batchEntryFilterForm instanceof FormGroup) {
            let filter = this.batchEntryFilterForm.getRawValue();
            let batchEntryIdList = new Array<String>();
            if (this.batchEntrySelectd.length > 0) {
                this.batchEntrySelectd.forEach((item) => {
                    batchEntryIdList.push(String(item.element.id));
                });
                filter.filter.value = batchEntryIdList.toString();
                delete filter.batchEntry;
                this.filteAndValues.push(filter.filter);
            }
        }

        if (this.specialityFilterForm instanceof FormGroup) {
            let filter = this.specialityFilterForm.getRawValue();
            let specialityIdList = new Array<String>();
            if (this.specialitySelectd.length > 0) {
                this.specialitySelectd.forEach((item) => {
                    specialityIdList.push(String(item.element.id));
                });
                filter.filter.value = specialityIdList.toString();
                delete filter.speciality;
                this.filteAndValues.push(filter.filter);
            }
        }

        if (this.professionalFilterForm instanceof FormGroup) {
            let filter = this.professionalFilterForm.getRawValue();
            let professionalIdList = new Array<String>();
            if (this.professionalSelectd.length > 0) {
                this.professionalSelectd.forEach((item) => {
                    professionalIdList.push(String(item.element.id));
                });
                filter.filter.value = professionalIdList.toString();
                delete filter.professional;
                this.filteAndValues.push(filter.filter);
            }
        }

        if (this.payTypeFilterForm instanceof FormGroup) {
            let filter = this.payTypeFilterForm.getRawValue();

            let payTypeIdList = new Array<String>();
            if (this.payTypeSelectd.length > 0) {
                this.payTypeSelectd.forEach((item) => {
                    payTypeIdList.push(String(item.element.id));
                });
                filter.filter.value = payTypeIdList.toString();
                filterLocalStorage.push(filter.filter);
                delete filter.payType;
                this.filteAndValues.push(filter.filter);
            }
        }

        if (this.documentTypeFilterForm instanceof FormGroup) {
            let filter = this.documentTypeFilterForm.getRawValue();
            let documentTypeIdList = new Array<String>();
            if (this.documentTypeSelectd.length > 0) {
                this.documentTypeSelectd.forEach((item) => {
                    documentTypeIdList.push(String(item.element.id));
                });
                filter.filter.value = documentTypeIdList.toString();
                delete filter.documentType;
                this.filteAndValues.push(filter.filter);
            }
        }

        if (this.rangeFilterForm instanceof FormGroup) {
            if (!this.rangeFilterForm.invalid) {
                let filter = this.rangeFilterForm.getRawValue();
                const date = `${filter.start == "Invalid date"
                    ? "0"
                    : moment(filter.start).format("yyyy-MM-DD")
                    },${filter.end === "Invalid date"
                        ? "0"
                        : moment(filter.end).format("yyyy-MM-DD")
                    }`;
                filter.filter.value = date;
                filterLocalStorage.push(filter.filter);
                delete filter.start;
                delete filter.end;
                this.filteAndValues.push(filter.filter);
            }
        }

        if (this.rangeDueDateFilterForm instanceof FormGroup) {
            if (!this.rangeDueDateFilterForm.invalid) {
                let filter = this.rangeDueDateFilterForm.getRawValue();
                const date = `${filter.start == "Invalid date"
                    ? "0"
                    : moment(filter.start).format("yyyy-MM-DD")
                    },${filter.end === "Invalid date"
                        ? "0"
                        : moment(filter.end).format("yyyy-MM-DD")
                    }`;
                filter.filter.value = date;
                filterLocalStorage.push(filter.filter);
                delete filter.start;
                delete filter.end;
                this.filteAndValues.push(filter.filter);
            }
        }

        if (this.rangeDatePayFilterForm instanceof FormGroup) {
            if (!this.rangeDatePayFilterForm.invalid) {
                let filter = this.rangeDatePayFilterForm.getRawValue();
                const date = `${filter.start == "Invalid date"
                    ? "0"
                    : moment(filter.start).format("yyyy-MM-DD")
                    },${filter.end === "Invalid date"
                        ? "0"
                        : moment(filter.end).format("yyyy-MM-DD")
                    }`;
                filter.filter.value = date;
                filterLocalStorage.push(filter.filter);
                delete filter.start;
                delete filter.end;
                this.filteAndValues.push(filter.filter);
            }
        }

        if (this.dateFilterForm instanceof FormGroup) {
            let filter = this.dateFilterForm.getRawValue();
            filter.filter.value = `${moment(filter.date).format("yyyy-MM-DD")}`;
            delete filter.date;
            this.filteAndValues.push(filter.filter);
        }

        if (this.billingAllUnitsFilterForm instanceof FormGroup) {
            let filter = this.billingAllUnitsFilterForm.getRawValue();
            filter.filter.value = filter.billingAllUnits;
            delete filter.billingAllUnits;
            this.filteAndValues.push(filter.filter);
        }

        if (this.statusFilterForm instanceof FormGroup) {
            let filter = this.statusFilterForm.getRawValue();
            filterLocalStorage.push(filter.filter);
            filter.filter.value = filter.status;
            delete filter.status;
            this.filteAndValues.push(filter.filter);
            this.statusCurrent.emit(filter.filter.value);
        }

        if (this.insuranceWebserviceForm instanceof FormGroup) {
            let filter = this.insuranceWebserviceForm.getRawValue();
            filter.filter.value = filter.status;
            delete filter.status;
            this.filteAndValues.push(filter.filter);
            this.statusCurrent.emit(filter.filter.value);
        }

        if (this.onlyBillingForm instanceof FormGroup) {
            let filter = this.onlyBillingForm.getRawValue();
            filter.filter.value = filter.status;
            delete filter.status;
            this.filteAndValues.push(filter.filter);
            this.statusCurrent.emit(filter.filter.value);
        }

        if (this.filterByOsDatedForm instanceof FormGroup) {
            let filter = this.filterByOsDatedForm.getRawValue();
            filter.filter.value = filter.status;
            delete filter.status;
            this.filteAndValues.push(filter.filter);
            this.statusCurrent.emit(filter.filter.value);
        }

        if (this.glossStatusFilterForm instanceof FormGroup) {
            let filter = this.glossStatusFilterForm.getRawValue();
            filter.filter.value = filter.status;
            delete filter.status;
            this.filteAndValues.push(filter.filter);
            this.statusCurrent.emit(filter.filter.value);
        }

        if (this.typeGuideForm instanceof FormGroup) {
            let filter = this.typeGuideForm.getRawValue();
            filter.filter.value = filter.typeGuide.id;
            delete filter.typeGuide;
            this.filteAndValues.push(filter.filter);
        }

        if (this.exameTypeForm instanceof FormGroup) {
            let filter = this.exameTypeForm.getRawValue();
            filter.filter.value = filter.exameType?.id;
            delete filter.exameType;
            if (filter.filter?.value !== undefined && filter.filter?.value !== null) {
                this.filteAndValues.push(filter.filter);
            }
        }

        if (this.statusAuthorizationForm instanceof FormGroup) {
            let filter = this.statusAuthorizationForm.getRawValue();
            filter.filter.value = filter.status?.status;
            delete filter.status;
            if (filter.filter?.value) {
                this.filteAndValues.push(filter.filter);
            }
        }
        if (this.statusPatientForm instanceof FormGroup) {
            let filter = this.statusPatientForm.getRawValue();
            filter.filter.value = filter.status?.status;
            delete filter.status;
            if (filter.filter?.value) {
                this.filteAndValues.push(filter.filter);
            }
        }

        if (this.statusOrderCustonForm instanceof FormGroup) {
            let filter = this.statusOrderCustonForm.getRawValue();
            filter.filter.value = filter.status?.status;
            delete filter.status;
            if (filter.filter?.value) {
                this.filteAndValues.push(filter.filter);
            }
        }

        if (this.recurrentFilterForm instanceof FormGroup) {
            let filter = this.recurrentFilterForm.getRawValue();
            filterLocalStorage.push(filter.filter);
            filter.filter.value = filter.recurrent == true ? "1" : "0";
            delete filter.recurrent;
            this.filteAndValues.push(filter.filter);
        }

        if (this.protocolFilterStatus instanceof FormGroup) {
            let filter = this.protocolFilterStatus.getRawValue();
            filter.filter.value = filter.status;
            delete filter.status;
            this.filteAndValues.push(filter.filter);
        }

        if (this.protocolFilterBalanceStatus instanceof FormGroup) {
            let filter = this.protocolFilterBalanceStatus.getRawValue();
            filter.filter.value = filter.status;
            delete filter.status;
            this.filteAndValues.push(filter.filter);
        }

        if(event?.key == "GENERIC_SEARCH"){
              this.filteAndValues.push(event);
        }

        this.filterValues.emit(this.filteAndValues);
        if (
            this.scope == "accounstPayable" ||
            this.scope == "accounstReceivable"
        ) {
            sessionStorage.setItem(
                `${this.scope}Filter`,
                JSON.stringify(filterLocalStorage)
            );
        }
    }

    compareSelectStatus(o1: any, o2: any): boolean {
        if (!o1 || !o2) {
            return false;
        }
        return o1.status === o2.status;
    }

    displayPatientFn(patient?: any) {
        if (!patient) {
            return "";
        }
        return patient.person.name ? patient.person.name : patient;
    }

    displayInsuranceFn(insurance?: any) {
        if (!insurance) {
            return "";
        }
        return insurance.name ? insurance.name : insurance;
    }

    displaySimpleFn(object?: any) {
        if (!object) {
            return "";
        }
        return object.name ? object.name : object;
    }

    displaySpecialityFn(speciality?: any) {
        if (!speciality) {
            return "";
        }
        return speciality.person.name ? speciality.person.name : speciality;
    }

    displayBatchEntryFn(speciality?: any) {
        if (!speciality) {
            return "";
        }
        return speciality.number ? speciality.number : speciality;
    }

    getBatchEntryFilter() {
        this.batchEntryListProvider
            .getBatchEntryFilter(this.entity.id)
            .then((res) => {
                const batchEntryFilter = res.body.data;
                batchEntryFilter.forEach((element) => {
                    this.createForm(element.filter, element.value);
                });
            });
    }

    getSendingToFinanceFilter() {
        this.sendingToFinanceListProvider
            .getSendingToFinanceFilter(this.entity.id)
            .then((res) => {
                const sendingToFinanceFilter = res.body.data;
                sendingToFinanceFilter.forEach((element) => {
                    this.createForm(element.filter, element.value);
                });
            });
    }
}
